// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__xKaW1","rootSmall":"AddTileButton_rootSmall__MsdNX"};